import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig,  provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {DatasetAwareComponent,DataSetItem} from "../dataset-aware.component";
import {get} from "lodash-es";



const DEFAULT_CLS = 'app-switch';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-switch',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmSwitch]',
  template: `<div role="group" class="btn-group btn-group-justified">
    <a *ngFor="let opt of datasetItems; let $index = index;"
       [title]="opt.label" focus-target
       href="javascript:void(0);"
       class="btn btn-default"
       [name]="'wm-switch-' + opt.key"
       [ngClass]="{'selected': opt.selected, 'disabled': disabled}"
          >
      <i *ngIf="opt.dataObject && opt.dataObject[iconclass]" aria-hidden="true" [ngClass]="['app-icon', opt.dataObject[iconclass] ]"></i>
      {{getDisplayField(opt) || opt.label}}
    </a>
  </div>
  <span [title]="selectedItem ? selectedItem.label : modelByKey"
        class="btn btn-primary app-switch-overlay switch-handle">
    <i *ngIf="iconclass"
       class="app-icon {{(selectedItem && selectedItem.dataObject) && selectedItem.dataObject[iconclass]}}"></i>
    {{selectedItem ? selectedItem.label : modelByKey}}
</span>
  <input [name]="name" class="model-holder ng-hide" [disabled]="disabled" [value]="modelByKey" [required]="required" aria-hidden="true">
  `,
  providers: [
    provideAsWidgetRef(SwitchComponent)
  ],
  exportAs: 'wmSwitch',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class SwitchComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-switch');
  options = [];
  selectedItem: DataSetItem;
  iconclass: any;
  public required: boolean;
  public name: string;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  getDisplayField(opt: any) {
    return get(opt, this.displayfield);
  }

}

